(() => {
  const key = 'hhc-favorites-v1';
  let saved = [];
  try { saved = JSON.parse(localStorage.getItem(key) || '[]'); if (!Array.isArray(saved)) saved = []; } catch (_) {}
  function render() {
    document.querySelectorAll('[data-favorite]').forEach(button => button.setAttribute('aria-pressed', String(saved.some(item => item.id === button.dataset.favorite))));
    const list = document.querySelector('[data-favorites-list]');
    if (!list) return;
    list.replaceChildren();
    const empty = document.querySelector('[data-favorites-empty]');
    if (empty) empty.hidden = saved.length > 0;
    saved.forEach(item => {
      const li = document.createElement('li');
      const imageLink = document.createElement('a');
      const link = document.createElement('a');
      const url = new URL(item.url, location.origin);
      if (url.origin !== location.origin) return;
      imageLink.href = link.href = url.pathname + url.search;
      const img = document.createElement('img');
      if (/^https:\/\//.test(item.image || '') || /^\/\//.test(item.image || '')) img.src = item.image;
      img.alt = item.title; img.loading = 'lazy'; img.width = 76; img.height = 94;
      imageLink.append(img);
      const title = document.createElement('strong'); title.textContent = item.title;
      const price = document.createElement('span'); price.textContent = item.price;
      link.append(title, price);
      const remove = document.createElement('button'); remove.type = 'button'; remove.textContent = '×'; remove.dataset.favoriteRemove = item.id; remove.setAttribute('aria-label', list.dataset.removeLabel);
      li.append(imageLink, link, remove); list.append(li);
    });
  }
  function persist() { try { localStorage.setItem(key, JSON.stringify(saved)); } catch (_) {} render(); }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-favorite]');
    if (button) {
      const id = button.dataset.favorite;
      if (saved.some(item => item.id === id)) saved = saved.filter(item => item.id !== id);
      else saved.push({id, title: button.dataset.favoriteTitle, url: button.dataset.favoriteUrl, image: button.dataset.favoriteImage, price: button.dataset.favoritePrice});
      persist();
    }
    const remove = event.target.closest('[data-favorite-remove]');
    if (remove) { saved = saved.filter(item => item.id !== remove.dataset.favoriteRemove); persist(); }
    if (event.target.closest('[data-open="FavoritesDrawer"]')) render();
  });
  const ready = () => {
    document.querySelectorAll('[data-card-swatch]').forEach(button => {
      if (button.dataset.image) {
        button.style.backgroundImage = `url("${button.dataset.image}")`;
        button.style.backgroundSize = 'cover'; button.style.backgroundPosition = 'center';
      }
    });
    render();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready); else ready();
  document.addEventListener('shopify:section:load', ready);
})();
